const translations = {
  // Header / view badges
  prologueResults: 'RESULTADOS DO PRÓLOGO',
  startPositionSelection: 'SELEÇÃO DE POSIÇÃO DE PARTIDA',
  appTitle: 'APLICAÇÃO DE SELEÇÃO DE ORDEM DE PARTIDA',
  pickOrder: 'Ordem de Escolha',
  poweredBy: 'Desenvolvido por',

  // Toolbar tooltips
  zoomIn: 'Ampliar',
  zoomOut: 'Reduzir',
  configuration: 'Configuração',
  connectingZigbee: 'A ligar…',
  disconnectZigbee: 'Desligar Zigbee',
  connectZigbee: 'Ligar Zigbee',
  zigbeeConnectError: 'Falha na ligação do receptor Zigbee sem fios',
  zigbeeConnected: 'Receptor Zigbee sem fios ligado com sucesso.',
  zigbeeDeviceNotPaired: 'O comando não está emparelhado. Mantém premido o botão CIMA durante 10 segundos até o LED piscar. Quando a luz ficar constante, o comando está emparelhado. Tempo restante para emparelhar:',
  zigbeeDevicePaired: 'Comando emparelhado com sucesso e ligado à rede.',
  zigbeePortInUse: 'A porta série está em uso. Feche outra aplicação que a esteja a utilizar e tente novamente.',
  exitEditMode: 'Sair do modo de edição',
  editParticipants: 'Editar participantes',
  reset: 'Repor',
  switchToPrologue: 'Ver Resultados do Prólogo',
  switchToStart: 'Ver Seleção de Posição de Partida',
  stopSession: 'Parar sessão',
  startSession: 'Iniciar sessão',
  sessionStarted: 'Sessão de posição de partida iniciada. Pilotos, escolham a vossa posição de partida!',
  loadFromAnube: 'Importar da Anube',
  addParticipant: 'Adicionar participante',

  // Session warning dialog
  startNewSession: 'Nova Sessão',
  sessionWarningBody: 'Já existem posições iniciadas. Começa uma nova sessão do zero ou continua a atual?',
  newSession: 'Nova Sessão',
  continueSession: 'Continuar',

  // DialogConfirm defaults
  resetTitle: 'Repor Ordem de Partida',
  resetBody: 'Todos os participantes e dados da sessão serão eliminados permanentemente.',
  resetConfirm: 'Eliminar Tudo',
  warningCannotBeUndone: 'Esta ação não pode ser desfeita.',
  cancel: 'Cancelar',
  confirm: 'Confirmar',

  // AddParticipantModal / EditParticipantModal shared
  brand: 'Marca',
  driver: 'Piloto',
  driverNamePlaceholder: 'Nome do piloto',
  coDriver: 'Co-Piloto',
  coDriverNamePlaceholder: 'Nome do co-piloto',
  team: 'Equipa',
  teamNamePlaceholder: 'Nome da equipa',
  allowChooseStart: 'Permitir escolher posição de partida',
  priorityPilot: 'Piloto prioritário',
  timeSec: 'Tempo (seg)',

  // AddParticipantModal
  addParticipantTitle: 'Adicionar Participante',
  add: 'Adicionar',

  // EditParticipantModal
  editParticipantTitle: 'Editar Participante',
  save: 'Guardar',

  // ConfigModal
  configTitle: 'Configuração',
  eventName: 'Nome do evento',
  showTime: 'Mostrar tempo do participante',
  showCodriver: 'Mostrar co-piloto',
  showTeam: 'Mostrar equipa',
  allParticipantsVisible: 'Todos os participantes visíveis antes de escolher',
  language: 'Idioma',
  close: 'Fechar',

  // RaceConfigModal
  loadFromAnubeTitle: 'Importar da Anube',
  raceNumber: 'Número da prova',
  raceNumberPlaceholder: 'ex: 305',
  loading: 'A carregar…',
  load: 'Carregar',
  loadError: 'Erro ao carregar. Verifique o número da prova.',
  itinerary: 'Itinerário',
  specialStage: 'Especial / Troço',
  applyAndFetch: 'Aplicar e Carregar',

  // Priority pilots field
  priorityPilotsLabel: 'Pilotos prioritários (por número)',
  priorityPilotsPlaceholder: 'ex: 201, 37, 5',
  priorityPilotsHint: 'Lista separada por vírgulas dos números de veículo que serão marcados como pilotos prioritários.',

  // Max participants
  maxParticipantsLabel: 'Participantes a importar',

  // FIA Rules
  useFiaRules: 'Usar Regras FIA Secção 33.1.1',
};

export default translations;